import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils.ts";
import { Collapsible, CollapsibleContent } from "@/components/ui/collapsible.tsx";
import { CollapsibleTrigger } from "@radix-ui/react-collapsible";
import { SidebarMenuButton, SidebarMenuSubButton } from "@/components/ui/sidebar.tsx";
import IconChevronDown from "@/assets/icons/ico-chevron-down.svg?react";

interface CollapseMenuItemProps {
  id: string;
  label: string
  path: string
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>
  active?: boolean;
  children?: CollapseMenuItemProps[]
}

export function CollapseMenuItem ({ icon: IconComponent, label, children } : CollapseMenuItemProps ) {
  const location = useLocation();
  const submenus = children ?? [];
  const isSubmenuActive = submenus.some((submenu) =>
    submenu.active === undefined ? submenu.path === location.pathname : submenu.active
  );

  const [isCollapsed, setIsCollapsed] = useState<boolean>(isSubmenuActive);

  return (
    <Collapsible className="w-full"
       open={isCollapsed}
       onOpenChange={setIsCollapsed}
    >
      <CollapsibleTrigger asChild>
        <SidebarMenuButton>
          <div className="w-full items-center flex justify-between">
            <div className="flex items-center gap-2 text-base">
              {IconComponent && (
                <IconComponent
                  className="w-6 h-6 text-current"
                  aria-hidden="true"
                />
              )}
              <p className="group-data-[collapsible=icon]:hidden">{label}</p>
            </div>
            <div className={cn("whitespace-nowrap group-data-[collapsible=icon]:hidden")}>
              <IconChevronDown className={cn("w-4 h-4 transition ease-in-out", isCollapsed ? "rotate-180" : "")} />
            </div>
          </div>
        </SidebarMenuButton>
      </CollapsibleTrigger>
      <CollapsibleContent>
        {submenus.map(({label, path, active}) => (
          <SidebarMenuSubButton
            key={path || label}
            variant={
              (active === undefined && location.pathname === path) || active
                ? "active"
                : "default"
            }
            asChild
          >
            <Link to={path} className="flex w-full h-full items-center justify-between gap-2">
              {label}
            </Link>
          </SidebarMenuSubButton>
        ))}
      </CollapsibleContent>
    </Collapsible>
  )
}